module.exports = __webpack_public_path__ + "img/Y_040_1p8c.3a31f73d.png";